module.exports = __webpack_public_path__ + "img/mobile-63.ebd0a51d.png";